export default "__VITE_ASSET__COtwJmID__"